import { Career } from './Career';

export class Booth {
    public career: Career;
    public object: Phaser.GameObjects.Image;
    public isComplete: boolean;
    public playerEnabled: boolean;
    public candidateEnabled: boolean;

    constructor(object: Phaser.GameObjects.Image, career: Career) {
        this.object = object;
        this.career = career;
        this.isComplete = false;
        this.playerEnabled = true;
        this.candidateEnabled = true;
    }
}



// WEBPACK FOOTER //
// ./src/games/CareerFairGame/objects/Booth.ts